import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { menuStyles } from "../ui/MenuStyles";
import { navItemStyle, navItemActive } from "../ui/NavStyles";
import { useCustomerRoles } from "../CustomerRolesContext";
import { ROLE_IT, ROLE_OPERATIONS } from "../customerRoles";

export default function OrganizationMenu() {
  const location = useLocation();
  const navigate = useNavigate();
  const { rolesReady, hasAnyRole } = useCustomerRoles();

  const isActive =
    location.pathname === "/organization" ||
    location.pathname.startsWith("/organization/");

  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    }

    function handleEsc(e) {
      if (e.key === "Escape") setOpen(false);
    }

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const items = useMemo(() => {
    const out = [
      { label: "Information", path: "/organization" },
      { label: "Notifications", path: "/organization/notifications" },
    ];
    if (rolesReady && hasAnyRole([ROLE_IT])) {
      out.splice(1, 0, { label: "Users", path: "/organization/users" });
    }
    if (rolesReady && hasAnyRole([ROLE_OPERATIONS, ROLE_IT])) {
      out.push({ label: "Software Downloads", path: "/organization/software" });
    }
    return out;
  }, [rolesReady, hasAnyRole]);

  return (
    <div ref={ref} style={{ position: "relative" }} data-tour="nav-organization">
      <button
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        style={{
          ...navItemStyle,
          ...menuStyles.trigger,
          ...(isActive ? navItemActive : {}),
        }}
      >
        Organization
        <span style={menuStyles.caret}>▾</span>
      </button>

      {open && (
        <div role="menu" style={menuStyles.popover}>
          {items.map((item) => (
            <button
              key={item.path}
              role="menuitem"
              style={menuStyles.item}
              onClick={() => {
                navigate(item.path);
                setOpen(false);
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
